module.exports = __webpack_public_path__ + "img/bg.11aa3a6b.png";